exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notification-area a {\n  font-weight: bold;\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.notification-area a:hover {\n  color: black;\n  text-decoration: underline;\n}\n\n.dismiss {\n  font-weight: bold;\n  font-size: 1.25rem;\n}", ""]);
